class Profile2More {
  constructor(profile2Lead) {
    this.$ = profile2Lead;
    this.openClassName = 'is-open';
    this.toggleButton = this.$.querySelector('.js-profile2-lead-toggle');
    this.content = this.$.querySelector('.m-profile2-txt');
    this.maxLine = 3;

    this.init();
  }

  init() {
    this.updateToggleVisibility();
    this.bind();
  }

  updateToggleVisibility() {
    const lineHeight = parseFloat(getComputedStyle(this.$).lineHeight);
    const maxHeight = lineHeight * this.maxLine;
    const height = this.content.scrollHeight;
    const isUnderMax = height <= maxHeight;

    this.toggleButton.hidden = isUnderMax;
    return isUnderMax;
  }

  bind(){
    this.toggleButton.addEventListener('click', () => {
      this.$.classList.toggle(this.openClassName);
    });

    window.addEventListener('resize', () => {
      this.updateToggleVisibility();
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  const profile2LeadEls = document.querySelectorAll('.js-profile2-lead');
  if (!profile2LeadEls.length) return;
  profile2LeadEls.forEach((profile2Lead) => {
    new Profile2More(profile2Lead);
  });
});
